import { Box, useTheme } from '@mui/material';
import { PrimaryButton } from 'sharedComponents/Buttons';
import { primaryButtonOverrideSx } from 'sharedComponents/Buttons/styles';
import { GreySecondaryButton } from 'sharedComponents/Buttons/GreySecondaryButton';
import { ATSConnectHiringRequestCreateFeedbackTestIds } from 'data-testids/ATS';
import { ViewCTAButtonsProps } from '../../../types';
import auth from 'utils/auth';

export const ViewCTAButtons: React.FC<ViewCTAButtonsProps> = ({
  onCancel,
  onEditClick,
  authorEmail,
}) => {
  const theme = useTheme();
  const currentUserEmail = auth.getUser()?.email;
  const isAuthor = authorEmail === currentUserEmail;
  const isSuperAdmin = auth.isSuperAdminUser();

  return (
    <Box
      sx={{
        paddingTop: theme.spacing(4),
        width: '100%',
        display: 'flex',
        justifyContent: 'end',
      }}
    >
      {(isSuperAdmin || isAuthor) && (
        <GreySecondaryButton
          onClick={onEditClick}
          dataTestId={ATSConnectHiringRequestCreateFeedbackTestIds.EDIT_CANCEL_BUTTON}
          sx={{
            width: '50%',
            marginRight: theme.spacing(1),
          }}
        >
          Edit
        </GreySecondaryButton>
      )}
      <PrimaryButton onClick={onCancel} sx={{ ...primaryButtonOverrideSx(theme), width: '50%' }}>
        Close
      </PrimaryButton>
    </Box>
  );
};
